import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";

import { buttonVariants } from "components/ui/button";
import { Calendar } from "components/ui/calendar";
import { Field } from "components/ui/field";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { dateNavBounds } from "components/NewAdvancedSearch/filters/dateNavBounds";

export function DateRangeFilter({ value, onChange }) {
  return (
    <Field className="tw:w-60">
      <Popover>
        <PopoverTrigger
          className={buttonVariants({
            variant: "outline",
            className:
              "tw:justify-start tw:px-2.5 tw:font-normal tw:bg-white tw:dark:bg-background",
          })}
          id="date-picker-range"
        >
          <CalendarIcon />
          {value?.from ? (
            value.to ? (
              <>
                {format(value.from, "LLL dd, y")} -{" "}
                {format(value.to, "LLL dd, y")}
              </>
            ) : (
              format(value.from, "LLL dd, y")
            )
          ) : (
            <span>Pick a date</span>
          )}
        </PopoverTrigger>
        <PopoverContent className="tw:w-auto tw:p-0" align="start">
          <Calendar
            mode="range"
            captionLayout="dropdown"
            defaultMonth={value?.from}
            selected={value}
            onSelect={onChange}
            numberOfMonths={2}
            {...dateNavBounds()}
          />
        </PopoverContent>
      </Popover>
    </Field>
  );
}
